import { Button, message } from 'antd';
import axios from 'axios';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ImageWithSkeleton from './ImageWithSkeleton';

function CardMedicines({ data, onDelete }) {
    const navigate = useNavigate();
    const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
    const API_URL = import.meta.env.VITE_API_URL;
    const accessToken = useSelector((state) => state.user.accessToken);

    const handleDelete = async () => {
        try {
            const response = await axios.delete(`${API_URL}Medicines?id=${data.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.status === 200) {
                message.success("Medicines deleted successfully");
                onDelete(data.id);
            }

        } catch (error) {
            console.error("Error deleting Medicines:", error);
            message.destroy();
            message.error("Failed to delete Medicines");
        }
    };

    const handleViewDetails = () => {
        navigate(`ViewMedicines/${data.id}`, { state: { data: data } });
    };
    return (
        <>
            <div className='flex flex-col sm:flex-row sm:space-x-5 w-full bg-white p-3 sm:p-5 rounded mb-4'>
                <div className='h-[132px] w-[132px] mx-auto sm:mx-0 mb-4 sm:mb-0'>
                    <ImageWithSkeleton
                        noRounded={true}
                        src={data.image || 'https://s3.us-east-2.amazonaws.com/followvita.com/src/47dd4265-9e57-479a-adc7-b8acab1489c6_Rectangle%202757.png'}
                        alt={data.name}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </div>
                <div className='flex flex-col w-full space-y-4'>
                    <div className='flex flex-col sm:flex-row items-center w-full justify-between mt-2'>
                        <p className='text-xl sm:text-2xl font-bold mb-3 sm:mb-0 text-center sm:text-left'>{data?.name || 'Default Title'}</p>
                        <div className='flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto'>
                            <Button
                                onClick={handleViewDetails}
                                className='w-full sm:w-auto'
                                style={{
                                    borderColor: "#3371EB",
                                    color: "#3371EB",
                                    padding: "10px 15px",
                                    fontSize: "14px",
                                    fontWeight: "400"
                                }}
                            >
                                View Details
                            </Button>
                            {userType == 1 ?
                                <Button
                                    onClick={handleDelete}
                                    className='w-full sm:w-auto'
                                    style={{
                                        borderColor: "#FF4D4F",
                                        color: "#FFFFFF",
                                        padding: "10px 15px",
                                        fontSize: "14px",
                                        backgroundColor: "#FF4D4F",
                                        fontWeight: "400"
                                    }}
                                >
                                    Delete
                                </Button> : null}
                        </div>
                    </div>
                    <div className='flex flex-col space-y-2 md:space-y-3'>
                        <div className='grid grid-cols-1 md:grid-cols-3 gap-2'>
                            <p className='text-sm sm:text-base font-normal'>Manufacturer: {data.manufacturer ? data.manufacturer : "Null"}</p>
                            <p className='text-sm sm:text-base font-normal'>Category: {data.category ? data.category : "Null"}</p>
                            <p className='text-sm sm:text-base font-normal'>Batch Number: {data.batchNumber ? data.batchNumber : "Null"}</p>
                        </div>
                        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2 sm:gap-4'>
                            <p className='text-sm sm:text-base font-normal'>Prescription Status: {data.prescriptionStatus == true ? "Active" : "Inactive"}</p>
                            <p className='text-sm sm:text-base font-normal'>Stock Quantity: {data.quantityPerPackage ? data.quantityPerPackage : "Null"}</p>
                            <p className='text-sm sm:text-base font-normal'>Strength: {data.strength ? data.strength : "Null"}</p>
                            <p className='text-sm sm:text-base font-normal'>Type: {data.type ? data.type : "Null"}</p>
                            <p className='text-sm sm:text-base font-normal'>Dose: {data.dose ? data.dose : "Null"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CardMedicines;
